import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from 'jbc-front/components/Button';
import { Edit } from 'jbc-front/components/icons';
import { ScrollSpy } from 'jbc-front/components/ScrollSpy/v2';
import { AnchorTarget } from '@/components/AnchorTarget';
import { Employee, RegularHealthCheckupResult } from '../../query';
import { Navi } from '../Navi';
import { AbdominalCircumference } from './View/AbdominalCircumference';
import { Hearing } from './View/Hearing';
import { OrderByDoctor } from './View/OrderByDoctor';
import { Vision } from './View/Vision';
import { Height } from './View/Height';
import { ChestXRay } from './View/ChestXRay';
import { Office } from './View/Office';
import { Symptoms } from './View/Symptoms';
import { BloodPressure } from './View/BloodPressure';
import { AnemiaTest } from './View/AnemiaTest';
import { HealthCheckupInstitution } from './View/HealthCheckupInstitution';
import { BloodLipidTest } from './View/BloodLipidTest';
import { Report } from './View/Report';
import { Electrocardiogram } from './View/Electrocardiogram';
import { Weight } from './View/Weight';
import { LiverFunctionTest } from './View/LiverFunctionTest';
import { BloodSugarTest } from './View/BloodSugarTest';
import { MedicalHistory } from './View/MedicalHistory';
import { SpecifiedWorks } from './View/SpecifiedWorks';
import { Urine } from './View/Urine';
import { SputumTest } from './View/SputumTest';
import styles from './PersonalResult.scss';

interface PersonalResultParams {
  employee: Employee;
  result: RegularHealthCheckupResult;
}

export const PersonalResult: FC<PersonalResultParams> = ({ employee, result }) => {
  const location = useLocation();
  const editLink = `/regular_health_checkup/personal_results/${employee.personalId}/${result.id}/edit`;

  return (
    <ScrollSpy location={location}>
      <div className={styles.row}>
        <div className={styles.sideColumn}>
          <Navi />
        </div>

        <div className={styles.mainColumn}>
          <div className={styles.actions}>
            <Button as={Link} to={editLink} icon={<Edit />} widthAuto>
              編集
            </Button>
          </div>

          <AnchorTarget name="office" />
          <Office result={result} editLink={editLink} />

          <AnchorTarget name="health_checkup_institution" />
          <HealthCheckupInstitution result={result} editLink={editLink} />

          <AnchorTarget name="medical_history" />
          <MedicalHistory result={result} editLink={editLink} />

          <AnchorTarget name="symptoms" />
          <Symptoms result={result} editLink={editLink} />

          <AnchorTarget name="height" />
          <Height result={result} editLink={editLink} />

          <AnchorTarget name="weight" />
          <Weight result={result} editLink={editLink} />

          <AnchorTarget name="abdominal_circumference" />
          <AbdominalCircumference result={result} editLink={editLink} />

          <AnchorTarget name="vision" />
          <Vision result={result} editLink={editLink} />

          <AnchorTarget name="hearing" />
          <Hearing result={result} editLink={editLink} />

          <AnchorTarget name="chest_x_ray" />
          <ChestXRay result={result} editLink={editLink} />

          <AnchorTarget name="sputum_test" />
          <SputumTest result={result} editLink={editLink} />

          <AnchorTarget name="blood_pressure" />
          <BloodPressure result={result} editLink={editLink} />

          <AnchorTarget name="anemia_test" />
          <AnemiaTest result={result} editLink={editLink} />

          <AnchorTarget name="liver_function_test" />
          <LiverFunctionTest result={result} editLink={editLink} />

          <AnchorTarget name="blood_lipid_test" />
          <BloodLipidTest result={result} editLink={editLink} />

          <AnchorTarget name="blood_sugar_test" />
          <BloodSugarTest result={result} editLink={editLink} />

          <AnchorTarget name="urine" />
          <Urine result={result} editLink={editLink} />

          <AnchorTarget name="electrocardiogram" />
          <Electrocardiogram result={result} editLink={editLink} />

          <AnchorTarget name="order_by_doctor" />
          <OrderByDoctor result={result} editLink={editLink} />

          <AnchorTarget name="specified_works" />
          <SpecifiedWorks result={result} editLink={editLink} />

          <AnchorTarget name="report" />
          <Report result={result} editLink={editLink} />
        </div>
      </div>
    </ScrollSpy>
  );
};
